import React from "react";
import { Link } from "react-router-dom";
import CalltoActionSeven from "../../elements/calltoaction/CalltoActionSeven";
import footerOne from "../../data/footer/footerOne.json";
import ScrollTop from "./ScrollTop";
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
// import Copyright from './Copyright';

const footerIntem = footerOne[0];
const footerIntemOne = footerOne[1];
const footerIntemTwo = footerOne[2];
const footerIntemThree = footerOne[3];
// const footerIntemFour =  footerOne[4];
const footerIntemFive = footerOne[5];

const indexOneLink = footerIntemOne.quicklink;
const indexTwoLink = footerIntemTwo.quicklink;
const indexThreeLink = footerIntemThree.quicklink;

const FooterTwo = () => {
  return (
    <>
      <footer className="rn-footer footer-style-default variation-two">
        <CalltoActionSeven />
        <div className="footer-top">
          <div className="container">
            <div className="row">
              {/* Start Single Widget  */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="rn-footer-widget">
                  <h4 className="title">{footerIntemOne.title}</h4>
                  <div className="inner">
                    <ul className="footer-link link-hover">
                      {indexOneLink.map((data, index) => (
                        <li key={index}>
                          <Link to={`${data.url}`}>{data.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* End Single Widget  */}

              {/* Start Single Widget  */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="rn-footer-widget">
                  <div className="widget-menu-top">
                    <h4 className="title">{footerIntemTwo.title}</h4>
                    <div className="inner">
                      <ul className="footer-link link-hover">
                        {indexThreeLink.map((data, index) => (
                          <li key={index}>
                            <Link to={`${data.url}`}>{data.text}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Single Widget  */}

              {/* Start Single Widget  */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="rn-footer-widget">
                  <h4 className="title">{footerIntemThree.title}</h4>
                  <div className="inner">
                    <ul className="footer-link link-hover">
                      {indexTwoLink.map((data, index) => (
                        <li key={index}>
                          <Link to={`${data.url}`}>{data.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* End Single Widget  */}

              {/* Start Single Widget  */}
              {/* <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerIntemFour.title}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            {indexTwoLink.map((data, index) => (
                                                <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
              {/* End Single Widget  */}

              {/* Start Single Widget  */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="rn-footer-widget">
                  <h4 className="title">{footerIntemFive.title}</h4>
                  <div className="inner">
                    <h6 className="subtitle">{footerIntemFive.subtitle}</h6>
                    <ul className="social-icon social-default justify-content-start with-gradient">
                      <li>
                        <a
                          href="https://www.facebook.com/whatsondigitalagency"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="icon-link"
                          style={{ color: '#fff' }}
                        >
                          <FiFacebook color="#fff" strokeWidth="2.5" />
                          <span className="icon-label" style={{ fontSize: 12, color: "#fff" }}></span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://x.com/WhatsOn_UK"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="icon-link"
                          style={{ color: '#fff' }}
                        >
                          <FaXTwitter color="#fff" size="18" />
                          <span className="icon-label" style={{ fontSize: 12, color: "#fff" }}></span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/whatson_media/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="icon-link"
                          style={{ color: '#fff' }}
                        >
                          <FiInstagram color="#fff" strokeWidth="2.5" />
                          <span className="icon-label" style={{ fontSize: 12, color: "#fff" }}></span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/in/whatson-agency-07211a320/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="icon-link"
                          style={{ color: '#fff' }}
                        >
                          <FiLinkedin color="#fff" strokeWidth="2.5" />
                          <span className="icon-label" style={{ fontSize: 12, color: "#fff" }}></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* End Single Widget  */}
            </div>
          </div>
        </div>
      </footer>
      <style>
        {`
          .icon-label { display: none; }
          .icon-link:not(:has(svg)) .icon-label { display: inline; }
          .icon-link { color: #fff !important; }
          .icon-link svg { color: inherit !important; width: 18px; height: 18px; }
          .icon-link svg path,
          .icon-link svg circle,
          .icon-link svg rect,
          .icon-link svg line,
          .icon-link svg polyline { stroke: currentColor !important; }
        `}
      </style>
      <ScrollTop />
      {/* <Copyright /> */}
    </>
  );
};

export default FooterTwo;
